// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1POAk","signatureButtonsRight":"ModalSign_signatureButtonsRight__34_rq"};